export const url = {
  pro: "https://timelessbackend.kwintechnologies.com/api/",
  dev: "http://54.199.123.99/api/",
  local: "http://192.168.0.122:5000/api/",
  stage: "http://localhost:5000/api",
};

// export const API_URL = (field = "local") => url[field];
export const API_URL = (field = "pro") => url[field];
